import { memo } from 'react';
import { Typography } from '@mui/material';

import { appName } from '../../const/commonConst';
import theme from '../../../theme';

/**
 * アプリ名
 */
const AppName = () => {
	return (
		<Typography
			noWrap
			role="lable"
			aria-label={appName}
			sx={{
				fontSize: 20,
				fontWeight: 'bold',
				color: theme.palette.common.white,
				marginLeft: 2,
			}}
		>
			{appName}
		</Typography>
	);
};

export default memo(AppName);
